import React from "react";
import loaderImage from "../../../assets/images/animation_loader.gif";

const PageLoader = ({ isLoading }) => {
  return (
    <div
      className="animatedLoader h-100 "
      style={{
        display: isLoading ? "flex" : "none",
        position: isLoading ? "fixed" : "static",
      }}
    >
      <img
        alt="loader"
        loading="lazy"
        src={loaderImage}
        className="loaderImg"
      />
    </div>
  );
};

export default PageLoader;
